import { render } from "./Email.vue?vue&type=template&id=62306b34"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"
script.render = render

export default script